import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=ad67be0e&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=ad67be0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad67be0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad67be0e')) {
      api.createRecord('ad67be0e', component.options)
    } else {
      api.reload('ad67be0e', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=ad67be0e&scoped=true&", function () {
      api.rerender('ad67be0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/Product.vue"
export default component.exports